import api from './api';

const ENDPOINT = 'store-highlights';

const HighlightService = {
  get: (params = null) => api.get(`${ENDPOINT}`, { params }),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  save: (data) => api.post(`${ENDPOINT}`, data),
  update: (id, data) => api.put(`${ENDPOINT}/${id}`, data),
  delete: (id) => api.delete(`${ENDPOINT}/${id}`),
  reorder: (highlightId, order) =>
    api.put(`${ENDPOINT}/${highlightId}/reorder`, { order }),
  moveUp: (highlightId) => api.put(`${ENDPOINT}/${highlightId}/move-up`, null),
};

export default HighlightService;
